class HandleTheIntersection {
    init(elem = '.--viewport') {
        const handleIntersection = (entries, observer) => {
            entries.forEach(entry => {
                let element = entry.target;
                if (entry.isIntersecting) {
                    element.classList.add('--in-viewport');
                    element.classList.add('--has-viewport');
                } else {
                    element.classList.remove('--in-viewport');
                }
            });
        }

         // Initialize Intersection Observer
        let observer = new IntersectionObserver(handleIntersection, {
            threshold: 0.1 
        });

        // Select Observe Elements
        let elementsToObserve = document.querySelectorAll(elem);

        // Observe All Elements
        elementsToObserve.forEach(element => {
            observer.observe(element);
        });
        // -- END Intersection Observer
    }
}
  
 export default HandleTheIntersection;